












import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "legacy-invoice-provider": () =>
      import(
        "@/components/app/global/legacyInvoices/legacyInvoiceProvider.vue"
      ),
    "legacy-invoice-details": () =>
      import("@/components/app/global/legacyInvoices/legacyInvoiceDetails.vue")
  }
})
export default class ClientLegacyInvoice extends Vue {
  public invoiceId = this.$route.params.invoiceId;
}
